import React from "react"
import {StyledStandardSingleFacetCountWrapper} from "./components"
import {FacetState} from "../../../../../../../models/FacetsState"

interface StandardSingleFacetCountWrapperProps {
    facet: FacetState
    childtestid: string
}

export const StandardSingleFacetCountWrapper = ({facet, childtestid}: StandardSingleFacetCountWrapperProps) => {
    return (
        <StyledStandardSingleFacetCountWrapper data-testid={childtestid} $isDisabled={facet.d}>
            ({facet.c})
        </StyledStandardSingleFacetCountWrapper>
    )
}

export default StandardSingleFacetCountWrapper
